import { render, staticRenderFns } from "./DomainRegistrationPrice.vue?vue&type=template&id=55d35c3e&"
import script from "./DomainRegistrationPrice.vue?vue&type=script&lang=js&"
export * from "./DomainRegistrationPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports